import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import {
  DeviceConnectedLogo,
  DeviceDisconnectedLogo,
} from "../../../../Logo/logos";
import { BatteryIcon } from "../../../../icons/StatusIcons";

const LevelDevice = ({
  title,
  deviceId,
  deviceStatus,
  levelValue,
  lastUpdated,
  powerStatus,
  deviceType,
  fillPercent,
}) => {
  // Check if this is an expired subscription message
  const isExpiredSubscription = levelValue === "Subscription Expired";
  const isTransmitter = deviceType === "level_transmitter";
  const hasFill = fillPercent != null;

  return (
    <div
      style={{ backgroundImage: isTransmitter ? "none" : deviceStatus === "active" ? "url(/images/flow.gif)" : "url(/images/flow.png)" }}
      className={`device-card-flow${isTransmitter ? " device-card-transmitter" : ""}`}
    >
      <div className="device-card-head">
        <Tooltip title={title || ""} placement="top">
          <Link to={`/device-detail/${deviceId}`} style={{ textDecoration: "none" }}>
            <div className="device-card-title">
              {title}
            </div>
          </Link>
        </Tooltip>
        <div className="device-card-status">
          <>
            {!isExpiredSubscription && (
              deviceStatus === "active" ? (
                <Tooltip title="Device Connected">
                  <DeviceConnectedLogo />
                </Tooltip>
              ) : (
                <Tooltip title="Device Disconnected">
                  <DeviceDisconnectedLogo />
                </Tooltip>
              )
            )}
            {!isExpiredSubscription && (
              <Tooltip title={powerStatus == null ? "Power status unavailable" : powerStatus === 1 ? "Power On" : "Power Off"}>
                <BatteryIcon on={powerStatus == null ? null : powerStatus === 1} />
              </Tooltip>
            )}
          </>
        </div>
      </div>
      <div className="device-card-body">
        <div className="device-card-metrics">
          <div className="device-card-metric">
            {isExpiredSubscription ? (
              <div className="device-card-expired">{levelValue}</div>
            ) : (
              <>
                <div className="device-card-metric-label">Level:</div>
                <div className="device-card-metric-value">{levelValue}</div>
              </>
            )}
          </div>
        </div>
        {!isExpiredSubscription && (
          <div className="device-card-updated">
            <div className="device-card-metric">
              <div className="device-card-metric-label">Last Updated:</div>
              <div className="device-card-metric-value device-card-metric-stamp">{lastUpdated}</div>
            </div>
          </div>
        )}
        {isTransmitter && !isExpiredSubscription && (
          <div className="transmitter-gauge-group">
            <div
              className={`transmitter-gauge${deviceStatus === "active" && hasFill ? " transmitter-gauge-live" : ""}`}
              role="progressbar"
              aria-label="Level transmitter fill"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={hasFill ? fillPercent : undefined}
              aria-valuetext={hasFill ? `${fillPercent}% full` : "Level unavailable"}
            >
              <div className="transmitter-gauge-fill" style={{ height: `${hasFill ? fillPercent : 0}%` }} />
            </div>
            <span className="transmitter-gauge-percent">{hasFill ? `${fillPercent}%` : "--"}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LevelDevice;
